import { Component, OnInit } from '@angular/core';
import { HomeFilter, HomeFilterLevel } from 'src/app/models/client-configuration';
import { TopicService } from 'src/app/services/topic.service';
import { ThemaService } from '../../services/thema.service';
import { Util } from '../../util';

@Component({
  selector: 'app-topics',
  templateUrl: './topics.component.html',
  styleUrls: ['./topics.component.scss'],
})
export class TopicsComponent implements OnInit {
  topics: HomeFilter;

  constructor(
    private topicService: TopicService,
    themaService: ThemaService
  ) {
    if (topicService.topics.name === Util.THEMA_FILTER) {
      this.topics = themaService.groupTopics(topicService.topics);
    } else {
      this.topics = topicService.topics;
    }
  }

  ngOnInit() {}

  open(topic: HomeFilterLevel) {
    this.topicService.goToResults(topic);
  }

  goBack() {
    history.back();
  }
}
